import { PosPlugin } from 'plugins/plugin';
import { ErplyAttributes } from 'utils';

import { UIAccountSalesForm } from './components';
import { setPurchaseOrderNumber } from './rdx/actions';
import hpReducer, { getHipPocketState } from './rdx/reducers';

const pluginID = 'hip-pocket-plugin';

const HipPocketPlugin: PosPlugin = {
  id: pluginID,
  name: 'HipPocket Customizations',
  keywords: ['hippocket', 'customizations'],
  getStatus: () => {
    return {
      type: 'valid',
      message: `Ready`,
    };
  },
  reduxReducer: hpReducer,
  UIAccountSalesForm,
  onSaveSalesDocument: {
    on: (p, requests) => async (dispatch, getState) => {
      const { purchaseOrderNumber } = getHipPocketState(getState());

      return requests.map(request => {
        if (
          request.requestName === 'saveSalesDocument' &&
          purchaseOrderNumber.length
        ) {
          return {
            ...ErplyAttributes.withoutFlatArray(request),
            ...ErplyAttributes.fromFlatArray(request).set(
              'PurchaseOrder',
              purchaseOrderNumber,
            ).asFlatArray,
          };
        }

        return request;
      });
    },
    after: () => async dispatch => {
      dispatch(setPurchaseOrderNumber(''));
    },
  },
  onResetShoppingCart: {
    after: () => async dispatch => {
      dispatch(setPurchaseOrderNumber(''));
    },
  },
};

export default HipPocketPlugin;
